/**
 * Rounds the value to 3 decimal places
 * @param value - the raw co2 abated value
 * @returns value rounded to 3 decimal places
 *
 * !!!! This function is really important and the rounding behavior (floor/round/ceil) as well !!!!
 */
export const roundCo2Abated = (value: number) => Math.round(Number((value * 1000))) / 1000;
